export default __webpack_public_path__ + "static/media/BlackFrame04.ba77c4c2.png";